import React,{Component} from 'react';


export default class ResultTable extends Component{
	render(){
		return(
			<div>
			{
			(this.props.result_data.length>0) &&
            <table className="table mb-0">
              <thead className="bg-light" responsive hover >
                <tr>
                  <th scope="col" className="border-0">
                    #
                  </th>
                  <th scope="col" className="border-0">
                    Name
                  </th>

                  {
                        this.props.subjects.map((item,i)=>{
                            return (<Header key={i} subject={item.subjectname} />)
                          })
                  }
                  <th scope="col" className="border-0">
                    Edit
                  </th>
                 
                  
                </tr>
              </thead>
             <tbody >
                
                {
                	this.props.result_data.map((item,i)=>{
                            return (<TRow key={i} 
                            			  index={i+1} 
                            			  data={item} 
                            			  marks_data={this.props.selected_exam_data}
                            			  modify_result={this.props.modify_result}
                            			  />
                            		)
                 	})
                }

              </tbody>
            </table>
            
           }
           </div>
		)
	}
}

class Header extends Component{
  render(){
    return(
        <th scope="col" className="border-0">
                  {this.props.subject}
        </th>
    )
  }
}





class TRow extends Component{


	constructor(props) {
	  super(props);
	
	  this.state = {subject_marks:[]};
		this.getColor = this.getColor.bind(this);
	}

	componentDidMount(){	
		var p = this.props.data.subjects;
		var marks_data = [];
		for (var key in p) {
    		if (p.hasOwnProperty(key)) {
    			marks_data.push({subject_name:key,marks:p[key]});    			
    		}
		}

		this.setState({subject_marks:marks_data});
	}


	getColor=(subject_name,marks)=>{
		var marks_data = this.props.marks_data().subjects;
		if(marks===null){
			return 'black';
		}
		for(var i=0;i<marks_data.length;i++){
			if(marks_data[i].subjectname===subject_name){
				if(parseInt(marks_data[i].passing) > parseInt(marks) ){
					return 'red';
				}
				else{
					return 'black';
				}
			}
		}
	}

	render(){
		return(

				<tr>
                  <td>{this.props.index}</td>
                  <td>{this.props.data.name}</td>
                 	{
						            this.state.subject_marks.map((item,i)=>{
                              return (<td key={i} style={{color:this.getColor(item.subject_name,item.marks)}}>{item.marks===null?"----":item.marks}</td>)
                 		 })
					         }              
                  <td style={{fontSize: 20,color:'green'}} onClick={()=>{this.props.modify_result(this.props.data.roll_no,this.props.data.name)}}><i class="material-icons">edit</i></td>
                  
                </tr>

		)
	}
}

